// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"SrOnly-module--srOnly--2Hn2L"};